module.exports = __webpack_public_path__ + "img/2019110802.d54a568e.jpg";